export default __webpack_public_path__ + "static/media/trainEngine.2351de9f.svg";